<template>
    <div>
        <v-card>
            <v-card-title>
                <v-icon color="primary">
                    mdi-account-cash-outline
                </v-icon>
                <span class="pl-2 pr-2">{{ $t('ops.transferCoins.title') }}</span>
                <info-tool-tip
                    :message="$t('ops.transferCoins.tooltip')"
                ></info-tool-tip>
            </v-card-title>
            <v-data-table
                item-key="id"
                :loading="isLoading"
                :loading-text="$t('ops.transferCoins.loadingText')"
                :headers="headers"
                :items="parents"
                :search="search"
            >
                <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        :label="$t('common.search')"
                        class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        depressed
                        color="primary"
                        @click="transfer(item)"
                        class="mx-1"
                    >
                        {{ $t('ops.transferCoins.transferButton') }}
                        <v-icon right dark> mdi-check </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import InfoToolTip from "@/components/InfoToolTip";
export default {
    components: {
        InfoToolTip,
    },
    data() {
        return {
            parents: [],
            isLoading: true,
            search: "",
            planDialog: false,
            valid: true,
            id: null,
            planTypeName: "",
            selectedPlan: null,
        };
    },
    computed: {
        headers() {
            return [
                { text: this.$t('ops.transferCoins.headers.id'), value: "id", align: "start", filterable: false },
                { text: this.$t('common.email'), value: "email" },
                { text: this.$t('common.name'), value: "name" },
                { text: this.$t('ops.transferCoins.headers.balance'), value: "balance" },
                { text: this.$t('common.actions'), value: "actions", sortable: false },
            ];
        },
    },
    mounted() {
        this.loadParents();
    },
    methods: {
        loadParents() {
            this.isLoading = true;
            this.parents = [];
            axios
                .get('/users/all-parents')
                .then(async (response) => {
                    this.parents = response.data.parents;
                })
                .catch((error) => {
                    this.$notify({
                        title: this.$t('common.error'),
                        text: this.$t('ops.transferCoins.fetchError'),
                        type: "error",
                    });
                    console.log(error);
                    this.$swal(this.$t('common.error'), error.response.data.message, "error");
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        transfer(parent) {
            this.$swal
                .fire({
                    title: this.$t('ops.transferCoins.title'),
                    text: this.$t('ops.transferCoins.transferPrompt', { name: parent.name }),
                    input: "number",
                    inputAttributes: {
                        min: 1,
                    },
                    inputValidator: (value) => {
                        if (!value || value <=0) {
                            return this.$t('ops.transferCoins.invalidNumber');
                        }
                    },
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: this.$t('ops.transferCoins.transferButton'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        let coins = result.value;
                        this.isLoading = true;
                        axios
                            .post("/users/transfer-coins", {
                                parent_id: parent.id,
                                coins: coins,
                            })
                            .then((response) => {
                                this.$notify({
                                    title: this.$t('common.success'),
                                    text: this.$t('ops.transferCoins.transferSuccess'),
                                    type: "success",
                                });
                                //update parent balance with coins
                                let index = this.parents.findIndex((p) => p.id === parent.id);
                                this.parents[index].balance = Number(this.parents[index].balance) + Number(coins);
                            })
                            .catch((error) => {
                                this.$notify({
                                    title: this.$t('common.error'),
                                    text: this.$t('ops.transferCoins.transferError'),
                                    type: "error",
                                });
                                console.log(error);
                                this.$swal(this.$t('common.error'), error.response.data.message, "error");
                            })
                            .then(() => {
                                this.isLoading = false;
                            });
                    }
                });
        },
    },
};
</script>
